import { renderValidations } from "../../shared/Table/table.utils";

const formConfig = [{ id: "email", required: true }];

export const FORM_OPTIONS = { validations: renderValidations(formConfig) };
